"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "card-points-item-first"
};
const _hoisted_2 = { key: 3 };
const _hoisted_3 = {
    key: 1,
    class: "card-points card-points-big"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CardRenderItemComponent = (0, vue_1.resolveComponent)("CardRenderItemComponent");
    return (typeof _ctx.victoryPoints !== 'number')
        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
            key: 0,
            class: (0, vue_1.normalizeClass)(_ctx.classes)
        }, [
            (_ctx.victoryPoints.targetOneOrMore)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
                    (_ctx.victoryPoints.item !== undefined)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderItemComponent, {
                            key: 0,
                            item: _ctx.victoryPoints.item,
                            "data-test": "item"
                        }, null, 8, ["item"]))
                        : (0, vue_1.createCommentVNode)("", true),
                    _cache[0] || (_cache[0] = (0, vue_1.createTextVNode)(" *:3 ", -1))
                ]))
                : (_ctx.victoryPoints.vermin)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 1 }, [
                        _cache[1] || (_cache[1] = (0, vue_1.createTextVNode)(" 10 ", -1)),
                        (0, vue_1.createVNode)(_component_CardRenderItemComponent, { item: _ctx.animal }, null, 8, ["item"]),
                        _cache[2] || (_cache[2] = (0, vue_1.createTextVNode)(" : -1/ ", -1)),
                        (0, vue_1.createVNode)(_component_CardRenderItemComponent, { item: _ctx.city }, null, 8, ["item"]),
                        _cache[3] || (_cache[3] = (0, vue_1.createTextVNode)(" * ", -1))
                    ], 64))
                    : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 2 }, [
                        (0, vue_1.createElementVNode)("div", null, (0, vue_1.toDisplayString)(_ctx.points), 1),
                        (_ctx.victoryPoints.item !== undefined)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderItemComponent, {
                                key: 0,
                                item: _ctx.victoryPoints.item,
                                "data-test": "item"
                            }, null, 8, ["item"]))
                            : (0, vue_1.createCommentVNode)("", true)
                    ], 64)),
            (_ctx.victoryPoints.asterisk === true)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, "*"))
                : (0, vue_1.createCommentVNode)("", true)
        ], 2))
        : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, (0, vue_1.toDisplayString)(_ctx.victoryPoints), 1));
}
